export enum USER_PERMISSIONS {
  ADMIN = 'ADMIN',
  USER_WRITE = 'USER_WRITE',
  USER_VIEW = 'USER_VIEW',
  ADMIN_USER_VIEW = 'USER_ADMINVIEW',
  ROOT_AND_PROVIDER_VIEW = 'ROOT_AND_PROVIDER_VIEW',
  ADMIN_USER_WRITE = 'USER_ADMINWRITE',
  USER_INVITE_WRITE = 'USER_INVITEWRITE',
  USER_INVITE_VIEW = 'USER_INVITEVIEW',
  PROVIDERS_USER_WRITE = 'USER_PROVIDERSWRITE',
  PROVIDER_USER_VIEW = 'USER_PROVIDERSVIEW',
  CUSTOMER_ADMIN = 'USER_ADMINIDENTITYVIEW',
}
